/**
 * Created by lvardarova on 29/04/16.
 */
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Tops(props) {
    return (
        <SvgIcon {...props}>
            <path d="M10.818,4.23L8.441,2.08C8.389,2.03,8.317,2,8.24,2H6.815C6.705,2,6.6,2.065,6.547,2.165 c-0.134,0.255-0.583,0.92-1.076,0.92c-0.421,0-0.798-0.505-1.038-0.93C4.381,2.06,4.281,2,4.175,2H2.692 C2.616,2,2.544,2.03,2.487,2.08L0.206,4.23C0.158,4.28,0.081,4.34,0,4.41C0.058,4.51,0.115,4.56,0.158,4.63l1.181,1.765 c0.072,0.1,0.11,0.15,0.225,0.295c0.091-0.085,0.158-0.12,0.225-0.175L2.391,6.03v5.66c0,0.08,0.005,0.19,0,0.31 c0.11,0,0.215,0,0.301,0h5.711c0.081,0,0.206-0.004,0.296-0.004c0-0.09,0.005-0.221,0.005-0.306V6.005L9.384,6.52 c0.072,0.055,0.167,0.11,0.268,0.19C9.718,6.6,9.781,6.505,9.824,6.43l1.056-1.815C10.919,4.55,10.952,4.495,11,4.4 C10.923,4.325,10.871,4.275,10.818,4.23z" />
        </SvgIcon>
    );
}

Tops.defaultProps = {
    viewBox: '0 0 11 16'
};

export default Tops;
